<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="9" :fill="color" />
    <path
      d="M15 9L9 15M9 9L15 15"
      stroke="#FFFFFF"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

// A filled status circle with a white cross: red by default, matching the
// "not migrated" indicator in the System table. Callers can override `color`.
withDefaults(defineProps<CbIconProps>(), {
  ...cbIconDefaults,
  color: "#E0625C",
});
</script>
